import { FC, useCallback } from "react";
import InputDate from "@common/ui-kit/inputs/input_date";
import { EventDateComponentProps } from '@pages/makeEvent/types';
import { useValidation } from "@pages/makeEvent/hooks/useValidation";
import DateSchema from '@pages/makeEvent/steps-components/eventDate-component/schema.ts'


const DATE_LIMITS = {
  min: () => new Date().toISOString().slice(0, 16),
  max: "2030-12-31T00:00"
} as const;

const startFieldName = "start_time" as const
const endFieldName = "end_time" as const

const EventDateComponent: FC<EventDateComponentProps> = ({ formik, setValidValue }) => {
	const validationData = {[startFieldName]: formik.values[startFieldName], [endFieldName]: formik.values[endFieldName]}
  const { errors: validationErrors } = useValidation(DateSchema, validationData);

	const handleStartTimeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const newStartTime = e.target.value
		formik.setFieldValue(startFieldName, newStartTime)
		setValidValue(startFieldName)(newStartTime)
		// Сброс времени окончания если оно меньше нового времени начала
		if (formik.values.end_time && new Date(formik.values.end_time) <= new Date(newStartTime)) {
			formik.setFieldValue(endFieldName, "")
			setValidValue(endFieldName)(null)
		}
	}, [formik])

	const handleEndTimeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const newEndTime = e.target.value
		formik.setFieldValue(endFieldName, newEndTime)
		setValidValue(endFieldName)(newEndTime)
		// Сброс времени начала если оно больше нового времени окончания
		if (formik.values.start_time && new Date(newEndTime) < new Date(formik.values.start_time)) {
			formik.setFieldValue(startFieldName, "")
			setValidValue(startFieldName)(null)
		}
	}, [formik])
	
	return (
		<>
		 <InputDate
				title={"Дата начала"}
				value={formik.values.start_time}
				onChange={handleStartTimeChange}
				min={DATE_LIMITS.min()}
				max={DATE_LIMITS.max}
				onBlur={formik.handleBlur}
				errorText={formik.touched[startFieldName] && validationErrors[startFieldName] ? validationErrors[startFieldName] : null}
				name={"start_time"}
				placeholder={""}
				type={""}
			/>
			<InputDate
				title={"Дата окончания"}
				value={formik.values.end_time}
				onChange={handleEndTimeChange}
				type="datetime-local"
				min={DATE_LIMITS.min()}
				max={DATE_LIMITS.max}
				errorText={formik.touched[endFieldName] && validationErrors[endFieldName] ? validationErrors[endFieldName] : null}
				name={"end_time"}
				onBlur={formik.handleBlur}
				placeholder={""}
			/>
		</>
	)
}

export default EventDateComponent